export default {
    LOAD_WEB_APP(state, web){
        state.items = web
    }
}